module.exports = __webpack_public_path__ + "static/media/icon_time.8a25d417.svg";